class Transaction {
    constructor(date, comment, sum) {
        this.date = date;
        this.comment = comment;
        this.sum = sum;
    };

    copy() {
        return new Transaction(this.date, this.comment, this.sum)
    }

    date() { return this.date}
    setDate(date) {this.date = date}
    comment() {return this.comment}
    setComment(comment) {this.comment = comment}
    sum() {return this.sum}
    setSum(sum) {this.sum = sum}
}

export default Transaction;
